import { inject, Injectable } from "@angular/core";
import { AuditLog } from "../models/audit-log";
import { PlatformService } from "../services/platform.service";
import { ApiService } from "./base-api/api.service";
import { EMPTY, map, Observable } from "rxjs";

@Injectable({
    providedIn: 'root',
})
export class AuditApiService {
    private readonly api = inject(ApiService);

    getAuditLogs(): Observable<AuditLog[]> {
        return this.api.get<{ data: AuditLog[] }>('audits').pipe(
            map(response => response.data)
        );
    }
}